<template>
  <div class="ai-check-container">
    <!-- Header Banner -->
    <div class="ai-header-banner">
      <div class="banner-overlay"></div>
      <div class="banner-content">
        <div class="banner-left">
          <div class="ai-icon-pulse">
            <i class="el-icon-office-building"></i>
          </div>
          <div>
            <h1 class="banner-title">DANH SÁCH ĐẠI LÝ CHO TRƯỜNG</h1>
            <p class="banner-subtitle">Thiết lập kết nối, cấu hình định danh đại lý đại diện thanh toán SePay cho các trường học.</p>
          </div>
        </div>
        <div class="banner-actions">
          <el-button type="success" class="gradient-btn green-btn" icon="el-icon-plus" @click="isOpenAddBrandDialog = true">
            Thêm đại lý mới
          </el-button>
        </div>
      </div>
    </div>

    <!-- Quick Stats Grid -->
    <div class="ai-stats-grid">
      <div class="stat-card blue">
        <div class="stat-icon"><i class="el-icon-folder-opened"></i></div>
        <div class="stat-info">
          <p class="stat-label">Tổng đại lý đã thiết lập</p>
          <h3 class="stat-value">{{ totalPage }}</h3>
        </div>
      </div>
      <div class="stat-card green">
        <div class="stat-icon"><i class="el-icon-circle-check"></i></div>
        <div class="stat-info">
          <p class="stat-label">Đang hoạt động (trang này)</p>
          <h3 class="stat-value">{{ stats.activeCount }}</h3>
        </div>
      </div>
      <div class="stat-card purple">
        <div class="stat-icon"><i class="el-icon-link"></i></div>
        <div class="stat-info">
          <p class="stat-label">Cổng kết nối</p>
          <h3 class="stat-value">SePay API</h3>
        </div>
      </div>
    </div>

    <!-- Filter Section -->
    <div class="glass-card mb-4">
      <el-form :inline="true" :model="dataFilter" class="modern-filter-form">
        <el-form-item label="Trường học">
          <el-select
            v-model="dataFilter.idSchool"
            filterable
            clearable
            placeholder="Tất cả các trường"
            class="modern-select"
            @change="getListBrandSchoolAccount"
          >
            <el-option
              v-for="item in schoolList"
              :key="item.id"
              :value="item.id"
              :label="`${item.id} - ${item.schoolName}`"
            />
          </el-select>
        </el-form-item>

        <el-form-item class="filter-actions">
          <el-button type="primary" icon="el-icon-search" @click="getListBrandSchoolAccount">Tìm kiếm</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- Table Section -->
    <div class="glass-card table-container">
      <el-table
        ref="multipleTable"
        :data="dataTable"
        v-loading="loading.table"
        element-loading-text="Đang tải thiết lập đại lý..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255,255,255,0.7)"
        class="modern-table"
        border
        highlight-current-row
        @selection-change="handleSelectionChange"
        :max-height="tableMaxHeight"
      >
        <el-table-column type="selection" width="55" align="center" />
        
        <el-table-column type="index" label="STT" width="55" align="center" />

        <el-table-column label="Tên đại lý" min-width="220" prop="full_name" fixed>
          <template slot-scope="{ row }">
            <span class="brand-full-name">{{ row.full_name }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Tên trường học" min-width="240" prop="nameSchool">
          <template slot-scope="{ row }">
            <span class="school-name-text">
              <i class="el-icon-school" style="color: #64748b; margin-right: 4px;"></i>
              {{ row.nameSchool }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="ID đại lý trên SePay" min-width="160" align="center" prop="xid">
          <template slot-scope="{ row }">
            <code class="code-badge">{{ row.xid }}</code>
          </template>
        </el-table-column>

        <el-table-column label="Tên viết tắt" min-width="130" align="center" prop="short_name">
          <template slot-scope="{ row }">
            <span class="short-name-text">{{ row.short_name }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Trạng thái hoạt động" min-width="180" align="center" prop="status">
          <template slot-scope="{ row }">
            <el-tag :type="getStatusTagType(row.status)" size="medium" effect="dark" class="status-tag-rect">
              {{ getStatusLabel(row.status) }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="Giới hạn học sinh" min-width="160" align="center" prop="onlinePaymentLimit">
          <template slot-scope="{ row }">
            <el-tag :type="row.onlinePaymentLimit ? 'danger' : 'success'" size="medium" effect="plain">
              {{ row.onlinePaymentLimit ? 'Giới hạn' : 'Không giới hạn' }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="Số học sinh thanh toán" min-width="160" align="center" prop="numberOnlinePayments">
          <template slot-scope="{ row }">
            <span class="payment-count-badge">{{ row.numberOnlinePayments || 0 }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Tác vụ" width="250" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="primary" size="mini" icon="el-icon-setting" @click="configBrand(row)">
              Cấu hình
            </el-button>
            <el-button type="success" size="mini" icon="el-icon-edit" @click="updateBrand(row)">
              Sửa
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- Pagination controls -->
      <div class="pagination-wrapper mt-3 flex justify-center">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentPageChange"
          :current-page.sync="dataFilter.page"
          :page-sizes="listSizePage"
          :page-size="dataFilter.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalPage"
        >
        </el-pagination>
      </div>
    </div>

    <!-- Dialogs -->
    <AddBrandDialogVersion2
      :isOpenAddBrandDialog="isOpenAddBrandDialog"
      @closeDialog="closeAddBrandDialog"
    />
    <UpdateBrandDialogVersion2
      :isOpenUpdateBrandDialog="isOpenUpdateBrandDialog"
      :brand="brand"
      @closeDialog="closeUpdateBrandDialog"
    />
    <ConfigBrandDialogVersion2
      :xid="xid"
      :isOpenConfigBrandDialog="isOpenConfigBrandDialog"
      @closeDialog="closeConfigBrandDialog"
    />
  </div>
</template>

<script>
import UpdateBrandDialogVersion2 from "@/views/sepay/dialog/UpdateBrandDialogVersion2.vue";
import sePayConnectionService from "@/services/SePayConnectionService";
import SystemConfigService from "@/services/AdminService/SystemConfigService";
import AddBrandDialogVersion2 from "@/views/sepay/dialog/AddBrandDialogVersion2.vue";
import ConfigBrandDialogVersion2 from "@/views/sepay/dialog/ConfigBrandDialogVersion2.vue";

export default {
  name: "BrandConnectedSePayVersion2",
  components: { ConfigBrandDialogVersion2, AddBrandDialogVersion2, UpdateBrandDialogVersion2 },
  data() {
    return {
      dataFilter: {
        idSchool: "",
        statusBankApiConnected: null,
        statusBillPayment: null,
        page: 1,
        limit: 50
      },
      schoolList: [],
      listSizePage: [50, 100, 200, 500, 1000],
      totalPage: 0,
      dataTable: [],
      xid: "",
      isOpenAddBrandDialog: false,
      isOpenUpdateBrandDialog: false,
      isOpenConfigBrandDialog: false,
      brand: {},
      listBrand: [],
      loading: {
        table: false
      }
    };
  },

  computed: {
    tableMaxHeight() {
      return this.$tableMaxHeightCardManager || 750;
    },

    stats() {
      let activeCount = 0;
      this.dataTable.forEach(x => {
        if (x.status === "Active") activeCount++;
      });
      return { activeCount };
    }
  },

  created() {
    this.findAllAppIconForSchool();
    this.getListBrandSchoolAccount();
  },

  methods: {
    async findAllAppIconForSchool() {
      try {
        const resp = await SystemConfigService.findSchoolConfig("", this.dataFilter.idSchool, true);
        if (this.dataFilter.idSchool === "") {
          this.schoolList = resp.data.data || [];
        }
      } catch (err) {
        console.error(err);
      }
    },

    handleCommand(command) {
      if (command === "addBrand") {
        this.isOpenAddBrandDialog = true;
      }
    },

    async getListBrandSchoolAccount() {
      this.loading.table = true;
      try {
        const res = await sePayConnectionService.getListBrandSchoolAccount(
          this.dataFilter.idSchool,
          this.dataFilter.limit,
          this.dataFilter.page
        );
        if (res.data.status === 200) {
          this.dataTable = res.data.data.data || [];
          this.totalPage = res.data.data.total || 0;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loading.table = false;
      }
    },

    configBrand(row) {
      this.xid = row.xid;
      this.isOpenConfigBrandDialog = true;
    },

    updateBrand(row) {
      this.isOpenUpdateBrandDialog = true;
      this.brand = row;
    },

    closeAddBrandDialog() {
      this.isOpenAddBrandDialog = false;
      this.getListBrandSchoolAccount();
    },

    closeUpdateBrandDialog() {
      this.isOpenUpdateBrandDialog = false;
      this.getListBrandSchoolAccount();
    },

    closeConfigBrandDialog() {
      this.isOpenConfigBrandDialog = false;
      this.getListBrandSchoolAccount();
    },

    handleSizeChange(value) {
      this.dataFilter.limit = value;
      this.dataFilter.page = 1;
      this.getListBrandSchoolAccount();
    },

    handleCurrentPageChange(value) {
      this.dataFilter.page = value;
      this.getListBrandSchoolAccount();
    },

    handleSelectionChange(value) {
      this.listBrand = value.map(item => item.id.toString());
    },

    getStatusTagType(status) {
      const types = {
        Active: "success",
        Pending: "primary",
        Suspended: "warning",
        Terminated: "danger",
        Cancelled: "info",
        Fraud: "danger"
      };
      return types[status] || "info";
    },

    getStatusLabel(status) {
      const labels = {
        Active: "Đang hoạt động",
        Pending: "Đang chờ xử lý",
        Suspended: "Đã tạm ngừng",
        Terminated: "Đã chấm dứt",
        Cancelled: "Đã hủy",
        Fraud: "Gian lận"
      };
      return labels[status] || status;
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-check-container {
  padding: 16px;
  background-color: #f4f6fa;
  min-height: calc(100vh - 120px);
}

/* Header Banner Styling */
.ai-header-banner {
  position: relative;
  border-radius: 12px;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  padding: 24px 32px;
  margin-bottom: 24px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(30, 60, 114, 0.15);

  .banner-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
  }

  .banner-content {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
    width: 100%;
  }

  .banner-left {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .ai-icon-pulse {
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid rgba(255, 255, 255, 0.3);
    box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);
    animation: iconPulse 3s infinite ease-in-out;

    i {
      font-size: 32px;
      color: #fff;
    }
  }

  .banner-title {
    color: #fff;
    font-size: 22px;
    margin: 0 0 6px 0;
    font-weight: 700;
    letter-spacing: 0.5px;
  }

  .banner-subtitle {
    color: rgba(255, 255, 255, 0.85);
    font-size: 13px;
    margin: 0;
  }

  .gradient-btn {
    border: none;
    font-weight: 600;
    transition: all 0.3s;

    &:hover {
      transform: translateY(-2px);
    }

    &.green-btn {
      background: linear-gradient(90deg, #10b981 0%, #059669 100%);
      box-shadow: 0 4px 10px rgba(16, 185, 129, 0.3);
      &:hover { box-shadow: 0 6px 15px rgba(16, 185, 129, 0.4); }
    }
  }
}

@keyframes iconPulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);
  }
  50% {
    transform: scale(1.08);
    box-shadow: 0 0 25px rgba(255, 255, 255, 0.4);
  }
}

/* Stats Cards Grid */
.ai-stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.stat-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  }

  .stat-icon {
    width: 48px;
    height: 48px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
  }

  .stat-info {
    flex: 1;
  }

  .stat-label {
    margin: 0 0 4px 0;
    font-size: 13px;
    color: #64748b;
  }

  .stat-value {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
  }

  /* Colors */
  &.blue {
    border-left: 4px solid #3b82f6;
    .stat-icon { background: rgba(59, 130, 246, 0.1); color: #3b82f6; }
  }
  &.green {
    border-left: 4px solid #10b981;
    .stat-icon { background: rgba(16, 185, 129, 0.1); color: #10b981; }
  }
  &.purple {
    border-left: 4px solid #8b5cf6;
    .stat-icon { background: rgba(139, 92, 246, 0.1); color: #8b5cf6; }
  }
}

/* Glassmorphic Cards */
.glass-card {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.05);
  padding: 20px;
}

.table-container {
  background: #fff;
  padding: 12px;
}

/* Modern Form Filters */
.modern-filter-form {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px;

  /deep/ .el-form-item {
    margin-bottom: 0 !important;
    margin-right: 0 !important;
  }

  /deep/ .el-form-item__label {
    font-weight: 600;
    color: #475569;
    padding-bottom: 6px;
  }

  .modern-select {
    width: 250px;
  }
}

/* Modern Table Styles */
.modern-table {
  border-radius: 8px;
  overflow: hidden;

  /deep/ th {
    background-color: #f8fafc !important;
    color: #475569;
    font-weight: 600;
    height: 48px;
  }

  /deep/ td {
    padding: 10px 0;
  }
}

.brand-full-name {
  font-weight: 700;
  color: #1e293b;
  font-size: 14px;
}

.school-name-text {
  font-weight: 600;
  color: #3b82f6;
}

.short-name-text {
  font-weight: 600;
  color: #475569;
}

.code-badge {
  background: #f1f5f9;
  padding: 3px 8px;
  border-radius: 6px;
  font-family: Consolas, Monaco, monospace;
  font-size: 12px;
  color: #64748b;
  border: 1px solid #cbd5e1;
}

.status-tag-rect {
  font-size: 12px;
  height: 24px;
  line-height: 22px;
  padding: 0 10px;
  border-radius: 6px;
  border: none;
}

.payment-count-badge {
  font-weight: 700;
  background-color: #f0fdf4;
  color: #166534;
  padding: 4px 12px;
  border-radius: 6px;
  border: 1px solid #bbf7d0;
}

.pagination-wrapper {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}
</style>